<template>
  <div class="rules" v-bind:style="{ paddingBottom: $store.state.paddingBottom + 'px' }">

    <NavigationBar>
      <template v-slot:left>
        <img v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg">
      </template>
      <template v-slot:center>
        Teamtip
      </template>
    </NavigationBar>

    <div v-if="userlang === 'de'" class="input-container" style="margin-top: 24px;">
      <div class="input-header" style="text-align: center">
        Danke für euren Support ❤️
      </div>
      <div class="input-infotext">
        Die vergangenen Wochen waren für unser Teamtip-Team intensiv. Zum Start der WM haben wir einen deutlich größeren
        Ansturm auf Teamtip erlebt, als wir erwartet hatten. Ihr habt uns im wahrsten Sinne des Wortes die Bude
        eingerannt. Darüber freuen wir uns riesig und sind dankbar 🙏.
      </div>
      <div class="input-infotext">
        Gleichzeitig hat unser System dieser hohen Last an einigen Stellen nicht standgehalten.  
        Viele von euch konnten Tipps nicht sofort abgeben. Es gab lange Ladezeiten, Ergebnisse
        wurden verzögert oder teilweise gar nicht angezeigt. Manche Funktionen liefen schlicht nicht so, wie sie sollten, 
        und der Tippspaß blieb an vielen Stellen leider auf der Strecke.
      </div>
      <div class="input-infotext">
        <b>Das entspricht natürlich nicht unserem Anspruch.</b> Umso dankbarer sind wir allen, die uns Feedback gegeben,
        Fehler gemeldet und trotz allem weiter mit Teamtip getippt haben. Auch wenn die vielen schlechten App-Store
        Bewertungen weh tun, gehören auch sie zum Feedback dazu und haben uns geholfen die Fehler zu beseitigen.
      </div>
      <div class="input-infotext">
        <b>Was wir seitdem verbessert haben</b><br>
        Wir haben fast Tag und Nacht daran gearbeitet, Teamtip stabiler und schneller zu machen:
        <ul style="padding-left: 24px;">
          <li>🚀 <b>Teamtip startet und lädt jetzt deutlich schneller</b> – egal ob beim Öffnen der App, beim Wechsel
            zwischen Seiten oder beim Abrufen von Ergebnissen.
          </li>
          <li>💪 <b>Wir haben die Stabilität deutlich verbessert und tun dies weiterhin,</b> damit Teamtip auch dann zuverlässig läuft, wenn besonders viele von euch gleichzeitig in der App aktiv sind.
          </li>
          <li>⚙️ <b>Im Hintergrund haben wir unsere technische Infrastruktur umfassend modernisiert.</b> Dadurch werden
            Anfragen effizienter verarbeitet und Teamtip ist für zukünftige Großereignisse und neue Funktionen deutlich
            besser aufgestellt. Zudem haben wir die Datensicherheit verbessert und es wurden mögliche Sicherheitslücken
            geschlossen.
          </li>
        </ul>
      </div>
      <div class="input-infotext">
        <b>Und was wir in Zukunft noch mit euch vorhaben</b><br>
        Die WM endet. Teamtip natürlich nicht. Wir arbeiten bereits an den nächsten Verbesserungen, damit eure nächste Bundesliga-, Champions-League- oder EM-Tipprunde noch besser wird.
        Und die Vorfreude auf die neue Saison hat schon begonnen: Die Spielpläne sind veröffentlicht und ihr könnt ab sofort wieder Tipprunden für die Bundesliga, die 2. Bundesliga, die Premier League und viele weitere <a href="/createuserbetgame">Wettbewerbe erstellen</a>. Auch unsere <a href="/mybetgames">öffentlichen Community-Tipprunden</a> sind bereits live – dort könnt ihr gemeinsam mit anderen Fußballfans um tolle Preise mittippen.
      </div>
      <div class="input-infotext">
        <b>Teamtip ist von Fußballfans für Fußballfans</b> und es soll für euch weiterhin kostenfrei bleiben. Euer Feedback hilft uns dabei, die App jeden Tag ein Stück besser zu machen. Danke, dass ihr diesen Weg auch weiter mit uns geht. Und wenn ihr wieder happy mit dem Tipperlebnis seid und Lust habt, freuen wir uns auch über eine <a @click.prevent="ratingClicked" href="">gute Bewertung im App Store</a>. Damit würdet ihr uns sehr helfen 🙏.
      </div>
      <div class="input-infotext">
        Euer Teamtip-Team
      </div>
      <div class="input-infotext">
        <img src="../assets/images/teamtip/spm_team.jpg" style="width: 100%; border-radius: 11px;">
      </div>
      <div class="input-infotext">
      </div>
    </div>
    <div v-else-if="userlang === 'fr'" class="input-container" style="margin-top: 24px;">
      <div class="input-header" style="text-align: center">
        Merci pour votre soutien ❤️
      </div>
      <div class="input-infotext">
        Ces dernières semaines ont été particulièrement intenses pour toute l'équipe Teamtip. Au lancement de la Coupe du Monde, nous avons connu un afflux d'utilisateurs bien plus important que prévu. Vous avez été incroyablement nombreux à nous rejoindre, et nous vous en sommes très reconnaissants 🙏.
      </div>
      <div class="input-infotext">
        Dans le même temps, notre système n’a pas été en mesure de supporter cette forte charge à certains endroits. Beaucoup d'entre vous n'ont pas pu enregistrer leurs pronostics immédiatement. Les temps de chargement étaient parfois longs, les résultats arrivaient en retard ou ne s'affichaient pas du tout, et certaines fonctionnalités ne fonctionnaient tout simplement pas correctement. Cela a malheureusement nui au plaisir de participer.
      </div>
      <div class="input-infotext">
      Bien sûr, cela ne correspond pas aux standards que nous nous fixons. Nous remercions donc d'autant plus tous ceux qui nous ont envoyé leurs retours, signalé des bugs et continué à utiliser Teamtip malgré ces difficultés. Même si les nombreux avis négatifs sur l'App Store nous ont fait mal, ils nous ont aussi permis d'identifier et de corriger les problèmes.
      </div>
      <div class="input-infotext">
        <b>Ce que nous avons amélioré</b><br>
        Nous avons travaillé quasiment jour et nuit pour rendre Teamtip plus rapide et plus fiable:
        <ul style="padding-left: 24px;">
          <li>🚀 <b>Teamtip démarre et charge désormais beaucoup plus rapidement,</b> que ce soit à l'ouverture de l'application, lors de la navigation ou pour consulter les résultats.
          </li>
          <li>💪 <b>Nous avons considérablement amélioré la stabilité de l’application et continuons à le faire,</b> afin que Teamtip reste fiable, même lorsque beaucoup d’entre vous utilisent l’application en même temps.
          </li>
          <li>⚙️ <b>En coulisses, nous avons entièrement modernisé notre infrastructure technique.</b> Les requêtes sont désormais traitées beaucoup plus efficacement, ce qui prépare Teamtip aux futurs grands événements sportifs et aux nouvelles fonctionnalités. Nous avons également renforcé la sécurité des données et corrigé plusieurs failles de sécurité potentielles.
          </li>
        </ul>
      </div>
      <div class="input-infotext">
        <b>Et pour la suite</b><br>
La Coupe du Monde touche à sa fin. Mais Teamtip continue l'aventure. Nous travaillons déjà sur de nouvelles améliorations afin que vos prochaines ligues de pronostics pour la Bundesliga, la Ligue des Champions, l'Euro et bien d'autres compétitions soient encore meilleures.
      </div>
      <div class="input-infotext">
        La nouvelle saison approche déjà : les calendriers sont publiés et vous pouvez dès maintenant <a href="/createuserbetgame">créer de nouvelles ligues de pronostics</a> pour la Bundesliga, la 2. Bundesliga, la Premier League et de nombreuses autres compétitions. Nos <a href="/mybetgames">ligues communautaires publiques</a> sont également disponibles : rejoignez d'autres passionnés de football et tentez de remporter de superbes récompenses.
Teamtip est créé par des passionnés de football, pour des passionnés de football, et nous souhaitons que l'application reste gratuite pour tous. Vos retours nous aident à améliorer Teamtip chaque jour. Merci de continuer cette aventure avec nous. Et si vous appréciez de nouveau votre expérience sur Teamtip, nous serions très heureux de recevoir un <a @click.prevent="ratingClicked" href="">avis positif sur l'App Store</a>. Cela nous aiderait énormément 🙏.
      </div>
      <div class="input-infotext">
        L'équipe Teamtip
      </div>
      <div class="input-infotext">
        <img src="../assets/images/teamtip/spm_team.jpg" style="width: 100%; border-radius: 11px;">
      </div>
      <div class="input-infotext">
      </div>
    </div>
    <div v-else class="input-container" style="margin-top: 24px;">
      <div class="input-header" style="text-align: center">
        Thank you for your support ❤️
      </div>
      <div class="input-infotext">
        The past few weeks have been intense for the Teamtip team. At the start of the World Cup, far more people joined Teamtip than we had expected. You really came out in full force, and we're incredibly grateful for that 🙏.
      </div>
      <div class="input-infotext">
        At the same time, our system was unable to handle this high load in some areas. Many of you weren't able to submit your predictions right away. Loading times were long, results were delayed or sometimes didn't appear at all, and some features simply didn't work as intended. As a result, the fun of predicting matches was affected for many of you.
      </div>
      <div class="input-infotext">
        This is, of course, not the experience we want to provide. That's why we're especially grateful to everyone who shared feedback, reported bugs, and continued using Teamtip despite these issues. Even though the many negative App Store reviews hurt, they were valuable feedback and helped us identify and fix the problems.
      </div>
      <div class="input-infotext">
        <b>What we've improved since then</b><br>
        We've been working almost around the clock to make Teamtip faster and more stable:
        <ul style="padding-left: 24px;">
          <li>🚀 <b>Teamtip now starts and loads much faster</b> – whether you're opening the app, switching between pages, or checking results.
          </li>
          <li>💪 <b>We’ve significantly improved the app’s stability and are continuing to do so,</b> so that Teamtip remains reliable even when many of you are using the app at the same time.
          </li>
          <li>⚙️ <b>Behind the scenes, we've completely modernized our technical infrastructure.</b> Requests are now processed much more efficiently, making Teamtip better prepared for future major tournaments and new features. We've also improved data security and closed potential security vulnerabilities.
          </li>
        </ul>
      </div>
      <div class="input-infotext">
        <b>What's next</b><br>
The World Cup may be coming to an end, but Teamtip certainly isn't. We're already working on more improvements to make your next Bundesliga, Champions League, European Championship, or any other prediction competition even better.
      </div>
      <div class="input-infotext">
The excitement for the new season has already begun: The fixtures have been released, and you can now <a href="/createuserbetgame">create prediction leagues</a> again for the Bundesliga, 2. Bundesliga, Premier League, and many other competitions. Our <a href="/mybetgames">public community prediction leagues</a> are also live, giving you the chance to compete with football fans from around the world for great prizes.
Teamtip is built by football fans for football fans, and we want to keep it free for everyone. Your feedback helps us improve the app every single day. Thank you for continuing this journey with us. And if you're enjoying Teamtip again, we'd really appreciate a <a @click.prevent="ratingClicked" href="">positive review in the App Store</a>. It would help us tremendously. 🙏
      </div>
      <div class="input-infotext">
        Your Teamtip Team
      </div>
      <div class="input-infotext">
        <img src="../assets/images/teamtip/spm_team.jpg" style="width: 100%; border-radius: 11px;">
      </div>
      <div class="input-infotext">
      </div>
    </div>        
    
    <div style="padding-top: 64px;"></div>

    <transition v-if="ratingOverlayOpened" name="review-modal">
      <div class="review-modal-mask">
        <div class="review-modal-wrapper">
          <div class="review-modal-container">
            <div class="input-header">
              {{ $t('review_request_title') }}
            </div>
            <div class="input-infotext">
              {{ $t('review_request_text') }}
            </div>
            <star-rating style="justify-content: center;" @rating-selected="ratingChanged($event)" :rating="rating" :show-rating="false"></star-rating>
            <div class="review-modal-footer">
              <button class="review-modal-default-button" @click="ratingSkipped()">
                {{ $t('later') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    
  </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar'

export default {
  name: 'BetgameInfo',
  components: { NavigationBar },
  data () {
    return {
      rating: 0,
      ratingOverlayOpened: false,
      ratingRequested: false
    }
  },
  created () {
  },
  computed: {
    userlang () {
      return this.$store.state.language
    },
    packageVersion () {
      return process.env.PACKAGE_VERSION || '0'
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'home' }).catch(err => {
      })
    },
    ratingClicked() {
      this.ratingRequested = true
      this.$store.dispatch('setReviewPopupShown', 1)
      this.ratingOverlayOpened = true
    },
    ratingSkipped() {
      this.ratingOverlayOpened = false
      this.$store.dispatch('addRating', {'rating': 0, 'date': new Date(),
        'version': this.buildVersion(), 'client': this.userAgent(), 'appOpened': this.appOpenedCount(),
        'reviewRequested': this.reviewRequestedCount(), 'info': '' } ).then(() => {})
    },
    ratingChanged(r) {
      this.rating = r
      this.ratingOverlayOpened = false
      this.$store.dispatch('addRating', {'rating': r, 'date': new Date(),
        'version': this.buildVersion(), 'client': this.userAgent(), 'appOpened': this.appOpenedCount(),
        'reviewRequested': this.reviewRequestedCount(), 'info': '' } ).then(() => {})
      if(this.rating === 5) {
        try {
          if (window.TeamtipAppInterface !== undefined && window.TeamtipAppInterface !== null) {
            const a = window.TeamtipAppInterface.requestAppStoreReview()
          } else if (window.webkit && window.webkit.messageHandlers.TeamtipAppInterface !== undefined && window.webkit.messageHandlers.TeamtipAppInterface !== null) {
            const b = window.webkit.messageHandlers.TeamtipAppInterface.postMessage('requestAppStoreReview')
          } else {
          }
        } catch (e) {
        }
      }
    }    
  }
}

</script>

<style lang="scss" scoped>
.input-infotext {
  color: var(--color-text);
}
</style>
